export default function (text, font, maxSize, alignContent, padding) {
    const div = document.createElement("div");
    div.style.setProperty("overflow", "hidden");
    div.style.setProperty("display", "grid");
    div.style.setProperty("justify-content", "left");
    div.style.setProperty("align-content", alignContent);
    div.style.setProperty("max-width", `${maxSize.width}px`);
    div.style.setProperty("max-height", `${maxSize.height}px`);
    div.style.setProperty("width", "100%");
    div.style.setProperty("height", "100%");
    div.style.setProperty("font-family", font.fontFamily);
    div.style.setProperty("font-size", `${font.fontSize}px`);
    div.style.setProperty("font-weight", `${font.fontWeight}`);
    div.style.setProperty("font-style", `${font.fontStyle}`);
    div.style.setProperty("line-height", "1");
    div.style.setProperty("padding", padding);
    div.style.setProperty("white-space", "pre-wrap");
    div.style.setProperty("box-sizing", "border-box");
    div.innerHTML = text;
    return div;
}
